<div *ngIf="vm$ | async as vm" class="survey-reactive-content">
  <ng-container *ngIf="vm.template as template" [ngSwitch]="vm.display">
    <div *ngSwitchCase="Display.submitting">
      <lib-survey-page-logo
        [title]="template.ending_title"
        [subtitle]="template.ending_subtitle"
        [description]="template.ending_description"
      >
        <div style="height: 70px">
          <div class="loader" style="margin: auto"></div>
        </div>
      </lib-survey-page-logo>
    </div>

    <div *ngSwitchCase="Display.result">
      <lib-evaluate-response></lib-evaluate-response>
    </div>

    <div *ngSwitchCase="Display.error">
      <lib-survey-page-logo
        title="Oops!"
        subtitle="Une erreur est survenue."
      ></lib-survey-page-logo>
      <div class="lib-evaluate-submit__buttons-row">
        <button
          mat-button
          data-test="previous-page"
          class="lib-evaluate-submit__buttons-row__back-btn"
          (click)="previousPage()"
        >
          <mat-icon color="#301D5E">keyboard_backspace</mat-icon>
          Retour
        </button>
      </div>
    </div>

    <div *ngSwitchDefault>
      <lib-survey-page-logo
        [title]="template.ending_title"
        [subtitle]="template.ending_subtitle"
        [description]="template.ending_description"
      >
        <img src="/surveys-assets/images/check.svg" />
      </lib-survey-page-logo>
    </div>
  </ng-container>
</div>
